import React from 'react';
import './VerifyTaskModal.css';

const VerifyTaskModal = ({ 
    show, 
    task, 
    action, 
    remarks, 
    onRemarksChange, 
    onSubmit, 
    onClose 
}) => {
    if (!show || !task) return null;

    const isVerify = action === 'verify';
    const assignedToDisplay = Array.isArray(task.assignedToName) 
        ? task.assignedToName.join(', ') 
        : task.assignedToName;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>{isVerify ? 'Verify Completed Task' : 'Remove Verification'}</h2>
                <div className="modal-body">
                    <div className="task-info">
                        <p><strong>Title:</strong> {task.title}</p>
                        <p><strong>Description:</strong> {task.description}</p>
                        <p><strong>Assigned To:</strong> {assignedToDisplay}</p>
                        <p><strong>Status:</strong> {task.status}</p>
                        <p><strong>Priority:</strong> {task.priority}</p>
                    </div>
                    <div className="form-group">
                        <label>
                            {isVerify ? 'Remarks (Optional)' : 'Reason for Unverifying (Optional)'}
                        </label>
                        <textarea 
                            value={remarks} 
                            onChange={(e) => onRemarksChange(e.target.value)}
                            placeholder={isVerify ? 'Add verification remarks...' : 'Why are you removing verification?'}
                            rows="4"
                        />
                    </div>
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="btn-secondary">
                        Cancel
                    </button>
                    <button 
                        onClick={onSubmit} 
                        className={isVerify ? 'btn-verify' : 'btn-unverify'}
                    >
                        {isVerify ? '✓ Verify Task' : '✗ Remove Verification'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerifyTaskModal;
